<!-- Intro module has
        * introductory page  [no panel]
        * tutorial
-->

<script module>
	import Home from "./Home.svelte";
	import Rules from "./Rules.svelte";
	import GetStarted from "./GetStarted.svelte";
	import Features from "./Features.svelte";
	import Intro from "./Intro.svelte";

	export const publicLayouts = [
		{page: 'home',      title: "Home",        Page: Home},
		{page: 'rules',     title: "Regeln",      Page: Rules},
		{page: 'tutorial',  title: "Get started", Page: GetStarted},
		{page: 'features',  title: "Features",    Page: Features},
		{page: 'intro',     title: "Einführung",  Page: Intro},
	].map(layout => Object.assign(layout, {module: 'public'}))
</script>


<script>
		import { view } from "../client.svelte.js";
		import Help from "../elements/Help.svelte";

		let Page = $derived(view.layout.Page)
</script>


<!-------------------------------- HTML -------------------------------------->

<main id='public'>
	<Page />

	<Help floating/>

</main>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">

	#public
		--panel-width: 380px
		display: grid
		grid-gap: 12px
		grid-template-columns: auto var(--help-width, 0)
		grid-template-areas: "main help"

</style>